export const break_xl = 1439.98;
export const break_lg = 1199.98;
export const break_md = 991.98;
export const break_sm = 767.98;
export const break_xs = 575.98;

export const break_xl_up = break_xl + 0.02;
export const break_lg_up = break_lg + 0.02;
export const break_md_up = break_md + 0.02;
export const break_sm_up = break_sm + 0.02;
export const break_xs_up = break_xs + 0.02;

export const mobileBrowser = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
